import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showWelcome: false,
    showAppGuide: false,
    showAppTour: false,
    currentStepLabel :'',
    currentStepIndex :0,
    sidebarRef:{},
    itemRect:{},
    navigateToItem:false,
    completePercentage: 0,
    completeTimestamp: null,
};

const AppTour = createSlice({
    name: 'appTour',
    initialState,
    reducers: {
        resetAppTourState: (state) => {
            state.showWelcome = false
            state.showAppGuide=false
            state.showAppTour= false
            state.currentStepLabel =''
            state.currentStepIndex =0
            state.sidebarRef={}
            state.itemRect={}
            state.navigateToItem=false
        },
        setFieldValue: (state, action) => {
            const { name, value } = action.payload;
            state[name] = value;
        },
    },
});

export const {
    resetAppTourState,
    setFieldValue
} = AppTour.actions;

export default AppTour.reducer;
